import { Injectable } from '@angular/core';
import { ITourOptions, TourGuideService } from './tour-guide.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LandingPagesTourService {

  constructor(private tourGuide: TourGuideService) {
  }

  /**
   * Set up Landing Pages Tour
   */
  setUpLandingPagesTour(notifier: Observable<any>) {
    this.tourGuide.addStepsAndStartTour([
      {
        titleTranslationKey: 'LANDING_PAGES_POPUP.TITLE',
        textTranslationKey: 'LANDING_PAGES_POPUP.DESCRIPTION',
        imgUrl: 'https://storage.googleapis.com/landing_pages_popup/landing_pages_rect.png',
        classes: 'max-w-500 bottom-left',
        buttons: [
          {
            classes: 'cancel-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.CANCEL',
            type: 'cancel',
          },
          {
            classes: 'next-button',
            textTranslationKey: 'CAMPAIGNS.LEARN_MORE',
            action: () => {
              window.open('https://www.g-xperts.net/local-landing-pages', '_blank');
              this.tourGuide.delegator.next();
            },
          }],

      },
    ], new ITourOptions('LANDING_PAGES_POPUP_SEEN',
        false,
        false,
        this.tourGuide.deferUntil(notifier)
    ));
  }
}

